const handleRipple = (element: HTMLElement, binding: { value?: { diameter?: number; backgroundColor?: string } }, ev: MouseEvent) => {
  const { diameter = 50, backgroundColor = '#000000' } = binding.value || {};
    
  const rippleElement = document.createElement('span');
  let currentDiameter = 1;
  let currentOpacity = 0.65;
  const animationHandler = setInterval(animateRippleSpread, 5);
  applyRippleStyle();
  
  function applyRippleStyle() {
    const elementCoordinates = element.getBoundingClientRect();
    const offsetY = ev.clientY - elementCoordinates.y;
    const offsetX = ev.clientX - elementCoordinates.x;
  
    rippleElement.style.position = 'absolute';
    rippleElement.style.height = '5px';
    rippleElement.style.width = '5px';
    rippleElement.style.borderRadius = '100%';
    rippleElement.style.backgroundColor = backgroundColor || '#000000';
    rippleElement.style.left = `${offsetX}px`;
    rippleElement.style.top = `${offsetY}px`;

    // @ts-expect-error: unlisted method
    ev.target?.appendChild(rippleElement);
  }
  
  function animateRippleSpread() {
    const maximalDiameter = diameter || 75;
    if (currentDiameter <= maximalDiameter) {
      currentDiameter++;
      currentOpacity -= 0.65 / maximalDiameter;
      rippleElement.style.transform = `scale(${currentDiameter})`;
      rippleElement.style.opacity = `${currentOpacity}`;
    } else {
      rippleElement.remove();
      clearInterval(animationHandler);
    }
  }
};
  
const vRipple = {
  mounted: (el: HTMLElement, binding: { value?: { diameter?: number; backgroundColor?: string } }) => {
    el.style.position = 'relative';
    el.style.overflow = 'hidden';
    el.addEventListener('click', (ev: MouseEvent) => handleRipple(el, binding, ev));
  }
};
  
export default vRipple;
  
